(function(){
    'use strict';
    angular.module('app')
    .controller('AdministrationAccountsController', function(
        $scope,
        $location,
        AdminCurrentUserTableService
    ){
        $scope.refresh =refresh;
        $scope.goBack = function(){
            $location.path('/administration')
        };

        $scope.goToAddAccount = function(){
            $location.path('/administration/add')
        };

        init()
        function init(){
            $scope.tableData = new AdminCurrentUserTableService().tableData
        }
        

        function refresh(){
            new AdminCurrentUserTableService().tableActions
        }
    })
})()


// WEBPACK FOOTER //
// ./js/controllers/administration/AdministrationAccountsController.js